import { createTheme, ThemeOptions } from '@mui/material/styles'

const theme: ThemeOptions = {
  typography: {
    h1: { fontSize: '2rem', fontWeight: 100, color: '#3b1a59' },
    h2: { fontSize: '1.75rem', fontWeight: 100 },
    h3: { fontSize: '1.5rem', fontWeight: 200 },
    h4: { fontSize: '1.25rem', fontWeight: 100 },
  },
  components: {
    MuiAppBar: { styleOverrides: { root: { height: 64 } } },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '.MuiInputBase-readOnly ~ div > button > svg': {
            display: 'none',
          },
          '.MuiInputBase-readOnly > .MuiChip-root:focus': {
            borderColor: '#51247A !important',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'standard' },
      styleOverrides: {
        root: {
          '& .MuiInputBase-readOnly::before, .MuiInputBase-readOnly::after': {
            borderBottomColor: 'rgba(0,0,0,0.1) !important',
            borderBottomWidth: '1px !important',
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: { cursor: 'pointer', '&.Mui-disabled': { cursor: 'pointer' } },
      },
    },
    MuiAlert: {
      styleOverrides: {
        filled: {
          '&.MuiAlert-filledWarning': {
            color: '#000',
            a: { color: '#000', '&:hover': { textDecoration: 'underline' } },
          },
          '&.MuiAlert-filledError': { a: { color: '#FFF', '&:hover': { textDecoration: 'underline' } } },
          '&.MuiAlert-filledInfo': {
            backgroundColor: '#1f5abf',
            a: { color: '#FFF', '&:hover': { textDecoration: 'underline' } },
          },
          '&.MuiAlert-filledSuccess': { a: { color: '#FFF', '&:hover': { textDecoration: 'underline' } } },
        },
        message: { flex: 1 },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
          subtitle1: 'span',
          subtitle2: 'span',
          body1: 'p',
          body2: 'p',
          inherit: 'p',
        },
      },
    },
  },
  palette: {
    background: { default: '#fafafa' },
    primary: {
      light: '#962A8B',
      main: '#51247A',
      dark: '#3b1a59',
    },
    secondary: {
      light: '#3c76d8',
      main: '#2464d0',
      dark: '#1f56b1',
    },
    warning: {
      light: 'rgb(255, 218, 117)',
      main: 'rgb(251, 184, 0)',
      dark: 'rgb(126, 92, 0)',
    },
    success: {
      light: '#00a700',
      main: '#238029',
      dark: '#005000',
    },
    error: {
      light: '#ff0000',
      main: '#951126',
      dark: '#790000',
    },
    info: {
      light: 'rgb(138, 214, 255)',
      main: 'rgb(2, 136, 209)',
      dark: 'rgb(0, 76, 117)',
    },
  },
}

export const muiTheme = createTheme(theme)
